import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { cleanText } from '../utils/utilityFunctions';
import { Header, ToLink } from './_Common';


const SearchBar = ({ onSearch }) => {
    const clearInput = () => {
        const input = document.getElementById("SearchInput");
        if (input) input.value = "";
        onSearch('');
    };
    return (
        <div className="input-group w-md-25">
            <input
                id="SearchInput" type="text"
                className="form-control rounded-0" placeholder="חיפוש.."
                onChange={(e) => onSearch(e.target.value)}
            />
            <span className="input-group-text rounded-0" onClick={clearInput}>
                <FontAwesomeIcon icon="fas fa-trash-alt" className="mx-auto" />
            </span>
        </div>
    );
};

const FilterButton = ({ item, isActive, handleOnClick }) => {
    const buttonStyle = item.color ? { backgroundColor: item.color.includes('#') ? item.color : `#${item.color}` } : {};
    return (
        <span
            className={`btn btn-${isActive ? 'primary active' : 'secondary'} btn-sm m-1`}
            style={buttonStyle}
            onClick={() => handleOnClick(item.id)}
        >
            {item.itemIcon && item.itemIcon.type === 'fa' && <FontAwesomeIcon icon={item.itemIcon.cssClass} className="mx-1" />}
            {item.name}
        </span>
    );
};


export function FilterSelect({ optionsItems, onFilterChange }) {
    const [activeItem, setActiveItem] = useState(null);

    const handleOnClick = (categoryId) => {
        if (activeItem === categoryId) {
            // If the category is already active, deactivate it
            setActiveItem(null);
            if (onFilterChange) { onFilterChange(null); }
        } else {
            setActiveItem(categoryId);
            if (onFilterChange) { onFilterChange(categoryId); }
        }
    };

    return (
        <div className="d-flex flex-wrap btn-group justify-content-center my-1">
            {optionsItems.map((item, index) => (
                <FilterButton item={item} isActive={activeItem === item.id} handleOnClick={handleOnClick} key={index} />))}
        </div>
    );
}

export function FilterCategories({ filterCategories, onFilterChange }) {
    const [activeCategoryId, setActiveCategoryId] = useState(null);

    const handleOnClick = (categoryId) => {
        if (activeCategoryId === categoryId) {
            // If the category is already active, deactivate it
            setActiveCategoryId(null);
            if (onFilterChange) { onFilterChange(null); }
        } else {
            setActiveCategoryId(categoryId);
            if (onFilterChange) { onFilterChange(categoryId); }
        }
    };

    return (
        <div className="d-flex flex-wrap btn-group justify-content-center my-1">
            {filterCategories.map((item, index) => (
                <FilterButton item={item} isActive={activeCategoryId === item.id} handleOnClick={handleOnClick} key={index} />))}
        </div>
    );
}

export const ItemsList = ({ header, msg, afterSearchBar, items, toHtml, filterCategories, noItemShow, displayType = "List", className = "py-3 w-md-90 mx-auto", liMoreCss = "" }) => {
    const [searchInput, setSearchInput] = useState('');
    const [activeFilter, setActiveFilter] = useState(null);

    const filteredItems = useMemo(() => {
        const terms = cleanText(searchInput).split(/\s+/); // Split the search input by spaces or commas (replaced by space in cleanText) into terms

        const results = items.filter(item => {
            const itemText = cleanText(item.textSearch);

            if (!activeFilter) return terms.every(term => itemText.includes(term));

            return item.category === activeFilter && terms.every(term => itemText.includes(term));
        });
        return toHtml(results);
    }, [searchInput, activeFilter, items, toHtml]);

    const hasItems = filteredItems.length > 0;
    const showNoItem = items.length === 0 && noItemShow;
    return (
        <div className={className}>
            <Header header={header} msg={msg} titleCss="h4" />
            {!showNoItem && <div className="d-flex flex-column flex-md-row  justify-content-between align-items-start">
                <SearchBar onSearch={setSearchInput} />
                {afterSearchBar && <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    {afterSearchBar}</div>}
            </div>}
            <div></div>
            {filterCategories && <FilterCategories filterCategories={filterCategories} onFilterChange={setActiveFilter} />}
            {displayType == 'List' && <div id="ListDiv">
                <ul className="list-group rounded-0 border-secondary p-0 mt-3">
                    {filteredItems.map((item, index) => (
                        <li key={index} className={`list-group-item d-flex flex-wrap justify-content-between align-items-center ${liMoreCss}`}>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>}
            {displayType === 'Cards' && (
                <div id="CardDiv" className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-3">
                    {filteredItems.map((item, index) => (
                        <div key={index} className="col">
                            {item}
                        </div>
                    ))}
                </div>
            )}
            <div className="container">
                {hasItems && <p className="text-center">סה"כ: {filteredItems.length} פריטים בחתך</p>}
                {!hasItems && !showNoItem && <p className="text-center my-3 fw-bold">אין פריטים העונים לחתך</p>}
                {showNoItem && <p className="text-center h3 my-5">
                    😕 אין פריטים מתאימים
                </p>}
            </div>
        </div>
    );
};